import { get, uniq } from 'lodash';
import { SectionType } from '../../types';
import { mixColumn, mixColumnNoWrap, mixLeftColumn, mixRightColumn, mixSpacer, mixSectionNoWrap, mixButton, mixImageWrapperFullWidth, } from '../../sections/mix-css-classes';
import { getRegionSpacing } from '../get-section-padding';
var TINY_WIDTH_PADDING = 12;
export function getHardCapMixColumnPaddingsForSmallScreenCss(_a) {
    var css = _a.css;
    var sectionSpacingObject = getRegionSpacing(css, SectionType.mix);
    return "\n  ." + mixLeftColumn + " > table > tbody > tr > td {\n    padding-top: " + Math.min(sectionSpacingObject.padding.top, 24) + "px!important;\n  }\n\n  ." + mixRightColumn + " > table > tbody > tr > td {\n    padding-bottom: " + Math.min(sectionSpacingObject.padding.bottom, 24) + "px!important;\n  }\n  ";
}
export function getMixColumnPaddingsForSmallScreenCss(_a) {
    var css = _a.css;
    var spacerHeight = Math.min(parseInt(get(css, 'so-global-region-mix-separator.marginBottom') || '20px', 10), 20);
    return "\n  ." + mixColumn + " > table > tbody > tr > td,\n  ." + mixColumnNoWrap + " > table > tbody > tr > td,\n  ." + mixLeftColumn + " > table > tbody > tr > td,\n  ." + mixRightColumn + " > table > tbody > tr > td {\n    padding: 0!important;\n  }\n\n  ." + mixLeftColumn + " {\n    padding-bottom: " + spacerHeight + "px!important;\n  }\n\n  ." + mixSpacer + " div {\n    height: " + spacerHeight + "px!important;\n  }\n  ";
}
export function getMixImageMaxWidthForSmallScreenCss() {
    return "\n    ." + mixLeftColumn + " img,\n    ." + mixRightColumn + " img {\n      max-width: none !important;\n      width: 100% !important;\n    }\n  ";
}
export function getSmallScreenMixImageFullWidthCss() {
    return "\n    ." + mixImageWrapperFullWidth + " {\n      max-width:100%!important;\n    }\n    ." + mixImageWrapperFullWidth + " img {\n      height: 100%!important;\n    }\n    ." + mixColumn + " img {\n      max-width: none !important;\n      width: 100% !important;\n    }\n  ";
}
export function getMobileCssForMulticolumnSetup(_a) {
    var css = _a.css;
    var spacerHeight = Math.min(parseInt(get(css, 'so-global-region-mix-separator.marginBottom') || '20px', 10), 20);
    // const mixButtonPadding = utils.padding([css['so-global-b1-mix']]);
    // // arbitrary selected numbers, kind of works even on 25/25/25/25 no wrap split
    // const horizontalLimit = 20;
    // const verticalLimit = 12;
    // const minPadding = {
    //   top: Math.min(mixButtonPadding.top, verticalLimit),
    //   bottom: Math.min(mixButtonPadding.bottom, verticalLimit),
    //   left: Math.min(mixButtonPadding.left, horizontalLimit),
    //   right: Math.min(mixButtonPadding.right, horizontalLimit),
    // };
    // const noWrapButtonPaddingOverride = isEqual(mixButtonPadding, minPadding)
    //   ? ''
    //   : utils.shorthand(minPadding);
    return "\n    ." + mixLeftColumn + ",\n    ." + mixColumn + " {\n      padding-bottom: " + spacerHeight + "px!important;\n    }\n\n    ." + mixSectionNoWrap + " > table > tbody > tr > td {\n      padding:0px 12px!important;\n    }\n\n    ." + mixColumnNoWrap + " > table > tbody > tr > td {\n      padding: 0px 8px!important;\n    }\n\n    ." + mixColumnNoWrap + "." + mixRightColumn + " > table > tbody > tr > td {\n      padding-bottom: " + spacerHeight + "px!important;\n    }\n    ";
    // ${
    //   noWrapButtonPaddingOverride &&
    //   `.${mixColumnNoWrap} > table > tbody > tr > td > table > tbody > tr > .${mixButton} > table > tbody > tr > td > a {
    //   padding:${noWrapButtonPaddingOverride}!important;
    // }`
    // }
}
export function getMobileMixMulticolumnCss(region) {
    var columnWidths = uniq(region.layout.rows[0].columns.map(function (_a) {
        var width = _a.width;
        return width || 50;
    }));
    var multicolumnsButtonWidth = "." + mixSectionNoWrap + " ." + mixButton + " > table > tbody > tr > td > a {\n    padding-left: " + TINY_WIDTH_PADDING + "px!important;\n    padding-right: " + TINY_WIDTH_PADDING + "px!important;\n  }";
    return columnWidths
        .map(function (width) { return "." + mixColumnNoWrap + "." + mixColumnNoWrap + "-" + width + " {\n        width: " + width + "%!important;\n      }"; })
        .concat(multicolumnsButtonWidth)
        .join('');
}
export function getMixSmallScreenCss(_a) {
    var css = _a.css;
    return [
        getMixImageMaxWidthForSmallScreenCss(),
        getMixColumnPaddingsForSmallScreenCss({ css: css }),
        getHardCapMixColumnPaddingsForSmallScreenCss({ css: css }),
        getMobileCssForMulticolumnSetup({ css: css }),
        getSmallScreenMixImageFullWidthCss(),
    ]
        .filter(Boolean)
        .join(' ');
}
export function getMixCss() {
    return "\n    ." + mixColumnNoWrap + " {\n      display: inline-block!important;\n    }\n  ";
}
//# sourceMappingURL=get-mix-section-style.js.map